/** Opens the installed native app (home). */
export const NATIVE_APP_HOME_SCHEME = 'x9://';
/** Universal / HTTPS target for QR scanners that ignore custom schemes. */
export const NATIVE_APP_UNIVERSAL = 'https://my.x9.app/';
/** Public Google Play listing (Android). iOS store URL is not live yet. */
export const ANDROID_PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.hwyah.x9';

export function openNativeApp() {
  window.location.href = NATIVE_APP_HOME_SCHEME;
}
